import React, { createContext, useContext } from 'react';
import '../styles/promotion-tokens.css';
import '../styles/promotion-layout.css';
import '../styles/promotion-content.css';

const PromotionThemeContext = createContext(false);

/** 관리자 선호를 읽거나 저장하지 않는 고객 System 테마 경계다. */
export function PromotionThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <PromotionThemeContext.Provider value={true}>
      <div className="promotion-theme promotion-page">{children}</div>
    </PromotionThemeContext.Provider>
  );
}

// Portal의 Content와 Overlay에도 같은 CSS 경계를 부여한다.
export function usePromotionTheme(): boolean {
  return useContext(PromotionThemeContext);
}
